module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"detail":"Details","buy_now":"Buy Now"}}')
  delete Component.options._Ctor
}
